<template>
  <div>
    <overlay :show="!loadingAll" rounded="sm">
      <Filtro />
      <SimulacaoGrupo />
      <Importante />
      <Share :callback="retornoCotacao" />
      <ModalIdade />
      <ModalOperadora />
      <ModalProdutos />
      <ModalProdutosAdesao />
      <ModalProdutoGrupos />
    </overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Filtro from "@/components/Filtro"
import Importante from "@/components/Importante"
import Share from "@/components/Share"
import swal from "sweetalert";

import ModalIdade  from "@/components/ModalIdade"
import ModalOperadora from "@/components/ModalOperadora"
import ModalProdutos from "@/components/ModalProdutos"
import ModalProdutosAdesao from "@/components/ModalProdutosAdesao"
import ModalProdutoGrupos  from "@/components/ModalProdutoGrupos"

import FlexTableHeaderScroll from "@/components/FlexTableHeaderScroll";

import Overlay from "@/components/Overlay";
import Loader from "@/components/Loader";

export default {
  props: ["hash"],
  data() {
    return {
      tipoFilter: null,
    }
  },
  mixins: [FlexTableHeaderScroll],
  computed: {
    ...mapGetters("share", {
      getCotacao: "getCotacao",
      loadingCotacao: "getLoading",
      filtros: "getFiltros"
    }),
    ...mapGetters('modalFilter', ['getFilters', 'getRows', 'getRowsObj']),
    ...mapGetters("cenario", {
      cenarios: "getCenarios",
    }),
    exibirCenarios() {
      return this.cenarios.length > 0;
    },
    loadingAll() {
      return !this.loadingCotacao;
    },
    showRecomendar() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'recomendar') : this.getFilters.length == 0 ? true : false
    },
    showAtuacao() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'atuacao') : this.getFilters.length == 0 ? true : false
    },
    showModalidade() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'modalidade') : this.getFilters.length == 0 ? true : false
    },
    showAcomodacao() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'acomodacao') : this.getFilters.length == 0 ? true : false
    },
    showCoparticipacao() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'coparticipacao') : this.getFilters.length == 0 ? true : false
    },
    showReembolso() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'reembolso') : this.getFilters.length == 0 ? true : false
    },
    showTaxasIOF() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'taxas-iof') : this.getFilters.length == 0 ? true : false
    },
    showInformacoes() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'informacoes') : this.getFilters.length == 0 ? true : false
    },
    showHospitais() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'hospitais') : this.getFilters.length == 0 ? true : false
    },
    showValores() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'valores') : this.getFilters.length == 0 ? true : false
    },
    showResumo() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'resumo') : this.getFilters.length == 0 ? true : false
    }
  },
  methods: {
    ...mapActions("share", ["cotacao", "updateFiltros"]),
    ...mapActions('modalFilter', ['load', 'update', 'updateRows']),
    ...mapActions("cenario", ["updateCenarios"]),
    ...mapActions("cenario",
    [
      "recuperaCenario",
      "removerPlanos",
      "resetRedes",
      "resetRegioes"
    ]),
    ...mapActions(
      "operadora",
      [
        "resetOperadora",
        "resetOperadoras",
        "resetProduto",
        "resetAdministradora",
        "resetEntidade"
      ]
    ),
    ...mapActions(
      "produto", [
        "resetProdutos",
      ]
    ),
    ...mapActions(
      "plano", [
        "resetPlanos",
        "resetGrupos",
        "resetGrupoTree",
        "resetPlanosPorRede",
        "resetValores"
      ]
    ),
    retornoCotacao(id, hash) {
      localStorage.setItem('cotacao_id', id)
      localStorage.setItem('cotacao_hash', hash)
      this.cotacao_id = id
      this.cotacao_hash = hash
      this.$route.query.hash = hash

    },
    checked(filters, type) {
      let ops = [...filters]
      let filter = ops.filter(filter => filter.data.item == type)
      let obj = filter.length > 0 ? filter.shift(1) : {}
      return obj.hasOwnProperty('state') ? obj.state.indeterminate || obj.state.checked : false
    },
    children(filters, key) {
      let filter = filters.find(f => f.data.item == key)
      return filter ? filter.children : []
    },
    async loadFilters() {
     console.log('Filtro::loadFilters()');
      await this.load({
        filters: this.getFilters,
        recomendar: [],
        atuacao: [],
        modalidade: [],
        acomodacao: [],
        coparticipacao: [],
        reembolso: [],
        taxas_iof: [],
        informacoes: [],
        hospitais: this.cenarios,
        valores: [
          "00-18",
          "19-23",
          "24-28",
          "29-33",
          "34-38",
          "39-43",
          "44-48",
          "49-53",
          "54-58",
          "59-+"
        ],
        resumos: []
      });

      this.filters = this.getFilters;
      localStorage.setItem("filters", JSON.stringify(this.getFilters));
      this.filtered();
    },
    async filtered() {
      const id = localStorage.getItem(process.env.VUE_APP_CLIENT_ID);
      const json = JSON.parse(id);
      const user = json?.user;
      let self = this
      this.filters = this.getFilters
      let rows = this.getRowsObj.map(t => {
        if (t.key == 'recomendar') t.show = self.showRecomendar ? 1 : 0
        if (t.key == 'atuacao') t.show = self.showAtuacao ? 1 : 0
        if (t.key == 'modalidade') t.show = self.showModalidade ? 1 : 0
        if (t.key == 'acomodacao') t.show = self.showAcomodacao ? 1 : 0
        if (t.key == 'coparticipacao') t.show = self.showCoparticipacao ? 1 : 0
        if (t.key == 'reembolso') t.show = self.showReembolso ? 1 : 0
        if (t.key == 'taxas-iof') t.show = self.showTaxasIOF ? 1 : 0
        if (t.key == 'informacoes') t.show = self.showInformacoes ? 1 : 0
        if (t.key == 'hospitais') t.show = self.showHospitais ? 1 : 0
        if (t.key == 'valores') t.show = self.showValores ? 1 : 0
        if (t.key == 'resumo') t.show = self.showResumo ? 1 : 0
        return t
      })
      this.updateRows(rows);
    }
  },
  async created() {
    console.log('SimulacaoEdit::created()');
    await this.cotacao(this.hash);
    const cotacao = this.getCotacao;

    if (cotacao.detalhes) {
      const filtros = cotacao.parametros.filtros;

      // O valor vem como string da API e deve ser numero
      filtros.acomodacao = parseInt(filtros.acomodacao)
      filtros.compulsorio = parseInt(filtros.compulsorio)
      filtros.coparticipacao = parseInt(filtros.coparticipacao)
      filtros.regras_aceitacao = parseInt(filtros.regras_aceitacao) ? true : false;
      filtros.somar_taxas = parseInt(filtros.somar_taxas)
      filtros.mei = parseInt(filtros.mei)

      localStorage.setItem("filtros", JSON.stringify(filtros))
      this.updateFiltros(filtros);

      this.update(cotacao.detalhes.filters);
      this.updateRows(cotacao.detalhes.rows);

      const cenarios = cotacao.detalhes.cenarios;
      this.updateCenarios(cenarios);

      localStorage.setItem('cotacao_id', cotacao.id)
      localStorage.setItem('cotacao_hash', this.hash)
      this.cotacao_id = cotacao.id
      this.cotacao_hash = this.hash

      localStorage.setItem('cotacao', JSON.stringify({
        url: process.env.VUE_APP_URL,
        assunto: cotacao.titulo,
        nomeCliente: cotacao.nome,
        emailCliente: cotacao.email,
        emailCopias: cotacao.detalhes?.emailCopias,
        whatsAppCliente: cotacao.telefone,
        msg: cotacao.detalhes.mensagem,
        arqSelected: cotacao.detalhes.arquivos,
        lead: cotacao.detalhes.lead
      }))

      await this.loadFilters()

      let vm = this;
      setTimeout(() => {
        vm.flexTableHeaderScroll();
      }, 5000);
    } else {
      localStorage.removeItem('cenarios')
      localStorage.removeItem('cotacao_id')
      localStorage.removeItem('cotacao_hash')
      localStorage.removeItem('toggleAllRegiao')
      localStorage.removeItem('toggleAllCidade')
      localStorage.removeItem('toggleRecomendar')
      localStorage.removeItem('showHospitais')
      localStorage.removeItem('showValores')

      await this.removerPlanos();
      await this.resetRedes();
      await this.resetRegioes();
      await this.resetOperadora();
      await this.resetOperadoras();
      await this.resetProduto();
      await this.resetAdministradora();
      await this.resetEntidade();
      await this.resetProdutos();
      await this.resetPlanos();
      await this.resetGrupos();
      await this.resetGrupoTree();
      await this.resetPlanosPorRede();
      await this.resetValores();

      swal("Cotação não encontrada !");
    }
  },
  mounted() {
    this.$nextTick(function() {
      let vm = this;
      setTimeout(() => {
        vm.flexTableHeaderScroll();
      }, 5000);
    });
  },
  components: {
    Overlay,
    Loader,
    Filtro,
    Importante,
    Share,
    ModalIdade,
    ModalOperadora,
    ModalProdutos,
    ModalProdutosAdesao,
    ModalProdutoGrupos,
    SimulacaoGrupo: () => import(/* webpackChunkName: "simulacao-chunk" */ "@/components/SimulacaoGrupo")
  }
}
</script>

<style>

</style>
